import React, { useState } from "react";
import TabbedViewWithDateSelect from "../../components/TabbedViewWithDateSelect/TabbedViewWithDateSelect";
import MonthWisePlan from "../../components/MonthWisePlan/MonthWisePlan";
import EmergencyAsnApproval from "../../components/EmergencyAsnApproval/EmergencyAsnApproval"
import LineoutApproval from "../../components/LineoutApproval/LineoutApproval"

const MonthlyPlanningView = ({ pageTitle, tabConfigType }) => {
  const [monthPlanCount, setmonthPlanCount] = useState(0);

  let tabsConfig = [];

  if (tabConfigType === "EMERGENCY") {
    tabsConfig = [
      {
        label: "Emergency ASN Approval",
        title: "Emergency ASN Approval",
        count: monthPlanCount,
        countColor: "blue",
        backgroundColor: "blue",
        component: EmergencyAsnApproval,
        props: { handleCountChange: setmonthPlanCount },
      },
    ];
  } else if (tabConfigType === "LINEOUT") {
    tabsConfig = [
      {
        label: "Line Out",
        title: "Line Out",
        count: monthPlanCount,
        countColor: "blue",
        backgroundColor: "blue",
        component: LineoutApproval,
        props: { handleCountChange: setmonthPlanCount },
      },
    ];
  } else {
    tabsConfig = [
      {
        label: "Monthly Plan",
        title: "Monthly Plan",
        count: monthPlanCount,
        countColor: "blue",
        backgroundColor: "blue",
        component: MonthWisePlan,
        props: { handleCountChange: setmonthPlanCount },
      },
    ];
  }
    return (
      <div>
        <TabbedViewWithDateSelect
        tabs={tabsConfig}
        pageTitle={pageTitle}
        />
      </div>
      
    );
  };

export default MonthlyPlanningView;